module.exports = __webpack_public_path__ + "media/images/icons/outlined/fire-08022ad0d46b4d9626e1b8ff7fadc81a.svg";